import "./styles/index.scss";
import { TbLayoutGrid, TbTable } from "react-icons/tb";
import useLabels from "../../hooks/useLabels";
import { Icon } from "../../components/Icon";

// Split from ./index (which re-exports them): the header and the tank grid load at startup and need only these,
// not the form fields with react-select and the date picker.
export const Switch = ({
  leftOption,
  rightOption,
  fixed = false,
  disabled = false,
  toggleHandler,
  status,
  negative = false,
  variant = "slider",
}) => {
  // "segmented": the two options side by side, the current one highlighted (view modes like table | cards).
  // Options may carry an `icon`. "slider" (default): label, sliding knob, label (on/off settings).
  if (variant === "segmented") {
    return (
      <div className="switch_segmented" role="group">
        {[
          { option: leftOption, isActive: !status },
          { option: rightOption, isActive: Boolean(status) },
        ].map(({ option, isActive }, index) => (
          <button
            key={index}
            type="button"
            className={`switch_segmented_option${isActive ? " active" : ""}`}
            aria-pressed={isActive}
            disabled={disabled}
            onClick={() => {
              if (!isActive && toggleHandler) toggleHandler();
            }}
          >
            {option.icon && <Icon icon={option.icon} size="sm" aria-hidden="true" />}
            {option.label}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div
      onClick={disabled ? null : toggleHandler}
      className={`switch_field ${disabled && !fixed ? "disabled" : ""} ${
        fixed ? "fixed" : ""
      }`}
    >
      <div
        className={`switch_field_left ${!status ? "active" : ""} ${
          negative ? "negative" : ""
        }`}
      >
        {leftOption.label}
      </div>
      <label className="switch_field_switch">
        <input
          className={`${disabled ? "disabled" : ""}`}
          disabled={disabled}
          type="checkbox"
          checked={status}
          onClick={(e) => e.stopPropagation()}
        ></input>
        <span
          className={`switch_field_slider ${
            disabled && !fixed ? "disabled" : ""
          } ${fixed ? "fixed" : ""} ${negative ? "negative" : ""}`}
        ></span>
      </label>
      <div
        className={`switch_field_right ${
          disabled && !fixed ? "disabled" : ""
        } ${fixed ? "fixed" : ""} ${status ? "active" : ""}`}
      >
        {rightOption.label}
      </div>
    </div>
  );
};

// Table | cards toggle shared by the list pages.
export const ViewSwitch = ({ status, toggleHandler, disabled }) => {
  const [getLabel] = useLabels();
  return (
    <Switch
      variant="segmented"
      leftOption={{ label: getLabel("listView"), icon: TbTable }}
      rightOption={{ label: getLabel("gridView"), icon: TbLayoutGrid }}
      toggleHandler={toggleHandler}
      status={status}
      disabled={disabled}
    />
  );
};
